// covered-by: frontends/carrie/src/routes/ask-puntt/utils/__tests__/usedConnectors.test.ts
import {
  EnvelopeSimple,
  FigmaLogo,
  GoogleDriveLogo,
  Kanban,
  MicrosoftTeamsLogo,
  Palette,
  type Icon,
} from "@phosphor-icons/react";

import asanaLogo from "../images/connectors/asana.png";
import sharepointLogo from "../images/connectors/sharepoint.png";
import wrikeLogo from "../images/connectors/wrike.png";

/**
 * Phosphor brand (or semantic stand-in) icons for Ask Puntt connectors.
 * Email uses EnvelopeSimple. Canva / Jira use Palette / Kanban until true
 * brand assets ship (Phosphor has no CanvaLogo / JiraLogo in this version).
 * All Phosphor marks render at {@link CONNECTOR_PHOSPHOR_WEIGHT} (outline).
 */
export const CONNECTOR_PHOSPHOR_WEIGHT = "regular" as const;

export const CONNECTOR_PHOSPHOR_ICONS: Partial<Record<string, Icon>> = {
  figma: FigmaLogo,
  google_drive: GoogleDriveLogo,
  "microsoft-teams": MicrosoftTeamsLogo,
  email: EnvelopeSimple,
  canva: Palette,
  jira: Kanban,
};

/**
 * Custom brand marks (PNG) for connectors Phosphor does not ship.
 * Sourced from product-provided Asana / Wrike / SharePoint logos.
 */
export const CONNECTOR_CUSTOM_LOGOS: Partial<Record<string, string>> = {
  asana: asanaLogo,
  wrike: wrikeLogo,
  sharepoint: sharepointLogo,
};

/** @deprecated All default connectors now have phosphor or custom marks. */
export const CONNECTORS_MISSING_BRAND_LOGO = [] as const;

/** @deprecated Prefer CONNECTORS_MISSING_BRAND_LOGO. */
export const CONNECTORS_MISSING_PHOSPHOR_LOGO = CONNECTORS_MISSING_BRAND_LOGO;

export type ConnectorMissingBrandLogo =
  (typeof CONNECTORS_MISSING_BRAND_LOGO)[number];

export type ConnectorMissingPhosphorLogo = ConnectorMissingBrandLogo;

export function connectorIconSource(
  connectorId: string,
): "phosphor" | "custom" | "emoji" {
  if (CONNECTOR_PHOSPHOR_ICONS[connectorId] != null) return "phosphor";
  if (CONNECTOR_CUSTOM_LOGOS[connectorId] != null) return "custom";
  return "emoji";
}
